import { InjectionToken } from '@angular/core';
import { GestureAdapter } from './gesture-adapter.interface';

export const GESTURE_ADAPTER = new InjectionToken<GestureAdapter>('GestureAdapter');

